/* eslint-disable no-param-reassign */

export const reverseToInitialFilterValue = arr =>
  arr.map(option => {
    if (option.checked) {
      option.checked = false
    }
    return option
  })
